import { makeStyles } from 'tss-react/mui'
import { darkBg } from '../../../assets/colors'


const useStyles = makeStyles()((theme) => ({
    root: {
        height: '23px',
        width: '23px',
        minWidth: '23px',
        borderRadius: '3px',
        padding: '3px',
        background: 'transparent !important',
        cursor: 'default',
        '&:hover': {
            background: 'transparent !important',
            outline: `1px solid ${theme.palette.mode === "dark" ? 'rgba(255,255,255,0.4)' : 'rgba(0,0,0,0.3)'}`,
            outlineOffset: '-1px',
        },
        position: 'relative'
    },
    inner: {
        height: '17px',
        width: '17px',
        minWidth: '17px',
        borderRadius: '2px',
    },
    selected: {
        outline: `1px solid ${theme.palette.primary.main}`,
        outlineOffset: '-1px',
        borderRadius: '3px',
        '&:hover': {
            outline: `1px solid ${theme.palette.primary.main}`,
        },
    }
}))

export default useStyles